interface HasName {
    firstName: string;
    lastName: string;
}

export function filterByFullName<T extends HasName>(memorials: T[], searchTerm: string, extraFields?: ((item: T) => string)[]): T[] {
    const regex = new RegExp(`\\b${searchTerm.toLowerCase()}`, "i");

    return memorials.filter((data) => {
        const fullName = `${data.firstName?.toLowerCase()} ${data.lastName?.toLowerCase()}`;
        if (regex.test(fullName)) return true;
        return extraFields?.some((getField) => regex.test(getField(data).toLowerCase())) ?? false;
    });
}

interface HasNameAndMessage {
    name: string;
    message?: string;
}

export function filterByNameOrMessage<T extends HasNameAndMessage>(entries: T[], searchTerm: string)
    : T[] {
    const regex = new RegExp(`\\b${searchTerm.toLowerCase()}`, "i");

    return entries.filter((data) => {
        return regex.test(data.name?.toLowerCase()) || regex.test(data.message?.toLowerCase() || "");
    });
}
